import { WizImage } from './wiz-image';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [WizImage],
  imports: [
    CommonModule
  ],
  exports: [WizImage]
})
export class WizImageModule { }
